import type { RemoteCacheClientOperationOptions } from '@ms-cloudpack/remote-cache';
import { getBundleLocation } from './getBundleLocation.js';
import type { PartialContext } from '../types/Context.js';
import { getRemoteCachePackageId } from './getRemoteCachePackageId.js';
import type { TargetEnvironment } from '@ms-cloudpack/common-types';

export async function createRemoteCacheClientOperationOptions(
  options: { packagePath: string; targetEnvironment: TargetEnvironment },
  context: PartialContext<'packageHashes' | 'packages', 'cachePath'>,
): Promise<RemoteCacheClientOperationOptions> {
  const { packagePath } = options;
  const { packages } = context;

  const { name, version } = await packages.get(packagePath);

  const localLocation = await getBundleLocation(options, context);

  return {
    id: await getRemoteCachePackageId(options, context),
    path: localLocation.path,
    friendlyName: `${name}@${version}`,
  };
}
